module.exports = require("core-js/modules/es.typed-array.last-index-of.js");